module.exports = __webpack_public_path__ + "media/bootstrap-icons/diagram-2-fill-1e19e2d6.svg";